import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	// findOrderList,
	forwardToFindMaintenanceOrderList,

	// findOrder,
	forwardToFindMaintenanceOrder,

	// changeOrderActivePage, 
	forwardToChangeMaintenanceOrderActivePage,

	// deleteOrder, 
	forwardToDeleteMaintenanceOrder,

	// openAddOrderModal, 
	forwardToOpenAddMaintenanceOrderModal,

	// openEditOrderModal,
	forwardToOpenEditMaintenanceOrderModal,

	// openEditOrderDetailModal,
	forwardToOpenEditMaintenanceOrderDetailModal,

	// openViewOrderModal,
	forwardToOpenViewMaintenanceOrderModal,

	forwardToFindMOrderDetails,

	forwardToFindCategories,
} from '../actions';

function checkShowCheckBox(roles) {
	return (roles.includes("ROLE_MAINTENANCE_ORDER_EDIT"));
}

function checkDisableAdd(roles) {
	return !(roles.includes("ROLE_MAINTENANCE_ORDER_EDIT"));
}

function checkDisableEdit(roles) {
	return !(roles.includes("ROLE_MAINTENANCE_ORDER_EDIT"));
}

const mapStateToProps = (state) => ({
	data: state.getIn(['maintenanceOrderListReducer', 'orderList']),
	activePage: state.getIn(['maintenanceOrderListReducer', 'activePage']),
	itemPerPage: state.getIn(['maintenanceOrderListReducer', 'itemPerPage']),
	totalPage: state.getIn(['maintenanceOrderListReducer', 'totalPage']),
	searchWord: state.getIn(['maintenanceOrderListReducer', 'searchWord']),
	pagingMaxButtons: 5,
	fields: {
		order_id: '訂單編號',
		customer_name: '客戶名稱',
		order_date: '訂單日期',
		due_date: '交期',
		sales: '負責業務'
	},
	keys: ['order_id'],
	searchKeys: ['orders.order_id', 'customers.customer_name', 'orders.sales'],
	showCheckBox: checkShowCheckBox(state.getIn(['authReducer', 'roles']).toJS()),
	disableAdd: checkDisableAdd(state.getIn(['authReducer', 'roles']).toJS()),
	disableEdit: checkDisableEdit(state.getIn(['authReducer', 'roles']).toJS()),
	showEditMore: true,
	edit1: {
		className: 'glyphicon glyphicon-pencil',
		showText: 'Edit Detail'
	},
	edit2: {
		className: 'glyphicon glyphicon-eye-open',
		showText: 'View'
	}

})

const mapDispatchToProps = (dispatch) => ({
	refresh: (pagingData) => {
		dispatch(forwardToFindMaintenanceOrderList(pagingData));
		dispatch(forwardToFindCategories());
	},

	changeActivepage: (pagingData, searchData) => {
		dispatch(forwardToChangeMaintenanceOrderActivePage(pagingData));
		dispatch(forwardToFindMaintenanceOrderList(pagingData, searchData));
	},
	deleteItems: (deleteKey, pagingData) => {
		dispatch(forwardToDeleteMaintenanceOrder(deleteKey, pagingData));
	},
	openAddModal: () => {
		dispatch(forwardToOpenAddMaintenanceOrderModal({ forInsert: true }));
	},
	handleEdit: (pk) => {
		dispatch(forwardToFindMaintenanceOrder(pk));
		dispatch(forwardToOpenEditMaintenanceOrderModal({ forInsert: false }));
	},
	handleEdit1: (pk) => {
		dispatch(forwardToFindMaintenanceOrder(pk));
		dispatch(forwardToFindMOrderDetails(pk.order_id));
		dispatch(forwardToOpenEditMaintenanceOrderDetailModal({ orderId: pk.order_id }));
	},
	handleEdit2: (pk) => {
		dispatch(forwardToFindMaintenanceOrder(pk));
		dispatch(forwardToFindMOrderDetails(pk.order_id));
		dispatch(forwardToOpenViewMaintenanceOrderModal());
	},
	search: (pagingData, searchData) => {
		dispatch(forwardToFindMaintenanceOrderList(pagingData, searchData));
	}
})

const MaintenanceOrderListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default MaintenanceOrderListContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceOrderListContainer.jsx